import useMutationApi from 'src/api/useMutationApi';

interface RequestBody {
  quantity?: number;
  unitPrice?: number;
  unit?: string;
  selectedProductVariantId?: string;
  addedInternally?: boolean;
}

const useCreateSalesOrderDraftLineItem = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
  onError?: () => void,
) => {
  return useMutationApi<RequestBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/line-items`,
    method: 'POST',
    options: {
      onSuccess,
      onError,
    },
  });
};

export default useCreateSalesOrderDraftLineItem;
